const ADMIN_STORAGE_KEY = 'financeAdvisor.admin';
const API_KEY_STORAGE_KEY = 'financeAdvisor.apiKey';

const encodeValue = (value) => window.btoa(encodeURIComponent(value));
const decodeValue = (value) => decodeURIComponent(window.atob(value));

export const storeAdminProfile = (admin) => {
  if (!admin) return;
  localStorage.setItem(ADMIN_STORAGE_KEY, JSON.stringify(admin));
};

export const getAdminProfile = () => {
  const payload = localStorage.getItem(ADMIN_STORAGE_KEY);
  if (!payload) return null;

  try {
    return JSON.parse(payload);
  } catch (_) {
    localStorage.removeItem(ADMIN_STORAGE_KEY);
    return null;
  }
};

export const storeApiKey = (apiKey) => {
  if (!apiKey) return;
  localStorage.setItem(API_KEY_STORAGE_KEY, encodeValue(apiKey));
};

export const getRawApiKey = () => {
  const encoded = localStorage.getItem(API_KEY_STORAGE_KEY);
  if (!encoded) return null;

  try {
    return decodeValue(encoded);
  } catch (_) {
    localStorage.removeItem(API_KEY_STORAGE_KEY);
    return null;
  }
};

export const clearSession = () => {
  localStorage.removeItem(ADMIN_STORAGE_KEY);
  localStorage.removeItem(API_KEY_STORAGE_KEY);
};
